import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import MovieSection from "@/pages/home/components/MovieSection";
import HotSection from "@/pages/home/components/HotSection";
import TopicSection from "@/pages/home/components/TopicSection";
import { movies } from "@/mocks/movies";

export default function Home() {
  const latest = [...movies].sort((a, b) => b.year - a.year).slice(0, 12);
  const hot = [...movies].sort((a, b) => b.plays - a.plays);
  const topRated = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 8);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroCarousel />
        <CategoryQuickLinks />

        <MovieSection
          title="最新影视推荐"
          subtitle="新片新剧抢先看，第一时间发现好内容"
          movies={latest}
          moreTo="/category/all"
        />

        <HotSection hot={hot} topRated={topRated} />

        <TopicSection />

        <section className="mx-auto max-w-[1400px] px-4 py-12 md:px-8 md:py-16">
          <div className="rounded-lg border border-background-200/70 bg-gradient-to-r from-primary-900/70 via-background-100 to-background-100 p-6 md:p-10">
            <h1 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              97视频 · 精彩影视内容在线观看平台
            </h1>
            <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
              97视频聚合电影、电视剧、综艺节目等丰富影视资源，覆盖多种类型与地区。
              我们提供清晰的信息展示、便捷的分类筛选与贴心的内容推荐，让你更快找到想看的内容，尽享舒适观影体验。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/category/movie"
                className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-compass-line text-lg" aria-hidden="true"></i>
                开始探索
              </Link>
              <Link
                to="/about"
                className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-200/60"
              >
                了解97视频
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}